"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouriteNotFound = void 0;
const wishlist_exception_1 = require("./wishlist-exception");
class FavouriteNotFound extends wishlist_exception_1.WishlistException {
    constructor(wishlistId, studyId) {
        super(`Favourite with study id ${studyId} from wishlist ${wishlistId} not found.`);
        this.name = 'FavouriteNotFound';
    }
}
exports.FavouriteNotFound = FavouriteNotFound;
